import defaultState from '@/store/IncidentView/defaultState';

export const CLEAR_STATE = 'CLEAR_STATE';
export const SET_INCIDENT_FIELDS = 'SET_INCIDENT_FIELDS';
export const SET_INCIDENT = 'SET_INCIDENT';
export const SET_TRANSMISSION_HISTORY = 'SET_TRANSMISSION_HISTORY';
export const SET_REQUEST_CODE = 'SET_REQUEST_CODE';
export const SET_EMT_LIST_CACHE = 'SET_EMT_LIST_CACHE';

export default {
  /**
   * Clear state.
   *
   * @param {Object} state - Entity state.
   */
  [CLEAR_STATE]: (state) => {
    Object.assign(state, defaultState());
  },

  /**
   * Saves list of incident fields.
   *
   * @param {Object} state - State.
   * @param {array} data - Data of table fields.
   */
  [SET_INCIDENT_FIELDS]: (state, data) => {
    state.incidentFields = data;
  },

  /**
   * Saves incident data.
   *
   * @param {Object} state - State.
   * @param {array} data - Data incident
   */
  [SET_INCIDENT]: (state, data) => {
    state.incident = data;
  },

  /**
   * Saves status of request.
   *
   * @param {Object} state - State.
   * @param int data - Data incident
   */
  [SET_REQUEST_CODE]: (state, data) => {
    state.requestCode = data;
  },

  /**
   * Saves incident data.
   *
   * @param {Object} state - State.
   * @param {array} data - Data transmission history
   */
  [SET_TRANSMISSION_HISTORY]: (state, data) => {
    state.transmissionHistory = data;
  },

  /**
   * Saves EMT list to cache.
   *
   * @param {Object} state - State.
   * @param {Object} payload - Payload containing clientId, and data
   */
  [SET_EMT_LIST_CACHE]: (state, { clientId, data }) => {
    const cacheKey = `client_${clientId}`;
    state.emtListCache[cacheKey] = {
      data,
      timestamp: Date.now(),
    };
  },
};
